import React from "react";
import { Link } from "react-router-dom";
import RutaPrivada from "./RutaPrivada";
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";

class Listarmultas extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            datosCargados: false,
            multas: [],
            buscar: ""
        };
    }

    componentDidMount() {
        this.cargarDatos();
    }

   cargarDatos = () => {

    fetch(api + "multas", {
        headers: authHeaders()
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {

        

        this.setState({
            datosCargados: true,
            multas: Array.isArray(datosRespuesta) ? datosRespuesta : []
        });

    })
    .catch(error => {


        this.setState({
            datosCargados: true,
            multas: []
        });

    });
}

    cambioBuscar = (e) => {

        this.setState({
            buscar: e.target.value
        });
    }

    generarPDF = () => {
  window.open("http://localhost/PMT/api/reporte_multas.php", "_blank");
    }

imprimirMulta = async (id) => {
    try {
        const respuesta = await fetch(api + `reportes/multas/${id}/imprimir`, {
            method: "GET",
            headers: authHeaders()
        });

        if (!respuesta.ok) {
            const error = await respuesta.text();
           
            alert("No se pudo imprimir la multa.");
            return;
        }

        const blob = await respuesta.blob();
        const fileURL = window.URL.createObjectURL(blob);

        window.open(fileURL, "_blank");

    } catch (error) {
      
        alert("Error al imprimir la multa.");
    }
};


anularMulta = async (idmulta) => {
    const confirmar = window.confirm("¿Está seguro de anular esta multa?");

    if (!confirmar) return;

    const motivo = window.prompt("Ingrese el motivo de la anulación:");

    if (!motivo || motivo.trim() === "") {
        alert("Debe ingresar un motivo.");
        return;
    }

    const usuario = JSON.parse(localStorage.getItem("usuario"));

    try {
        const respuesta = await fetch(api + "multas/" + idmulta + "/anular", {
            method: "POST",
            headers: authHeaders(),
            body: JSON.stringify({
                idusuario: usuario.idusuario,
                motivo: motivo
            })
        });

        const datos = await respuesta.json();

        if (datos.success) {
            alert("Multa anulada correctamente.");
            this.cargarDatos();
        } else {
            alert(datos.message || "No se pudo anular la multa.");
        }

    } catch (error) {
       
        alert("Error al conectar con el servidor.");
    }
}

verAnulacion = async (idmulta) => {
    try {
        const respuesta = await fetch(api + "multas/" + idmulta + "/anulacion", {
            headers: authHeaders()
        });

        const datos = await respuesta.json();

        if (datos.success) {
            alert(
                "Motivo: " + datos.anulacion.motivo +
                "\nUsuario: " + datos.anulacion.usuario +
                "\nFecha: " + datos.anulacion.fecha_anulacion
            );
        } else {
            alert(datos.message || "No se encontraron datos de anulación.");
        }

    } catch (error) {
       
        alert("Error al consultar la anulación.");
    }
}
    render() {
        const usuario = JSON.parse(localStorage.getItem("usuario"));
        const rol = Number(usuario?.rol);

        const { datosCargados, multas, buscar } = this.state;

        if (!datosCargados) {
            return <div>Cargando...</div>;
        }

        const multasFiltradas = multas.filter((multa) =>

            (multa.tipoplaca + multa.placa)
                 .toLowerCase()
                 .includes(buscar.toLowerCase())
        );

        return (

            <div className="card shadow">

                <div className="card-header bg-primary text-white">

                    <div className="d-flex justify-content-between align-items-center">

                        <h4 className="mb-0">
                            <i className="bi bi-search me-2"></i>
                            CONSULTAR MULTAS
                        </h4>

                      
                    {(Number(usuario?.rol) === 1 || Number(usuario?.rol) === 3) && (
                        <Link
                            to="/crearmultas"
                            className="btn btn-success"
                        >
                            <i className="bi bi-file-earmark-plus me-2"></i>
                            Nueva multa
                        </Link>
                    )}
                    </div>

                </div>

                <div className="card-body">

                    <div className="row mb-3">

                        <div className="col-md-6">

                            <input
                                type="text"
                                className="form-control"
                                placeholder="Buscar por placa"
                                value={buscar}
                                onChange={this.cambioBuscar}
                            />

                        </div>

                    </div>

                    <div className="table-responsive">

                        <table className="table table-bordered table-hover align-middle">

                            <thead className="table-dark">

                                <tr>
                                    <th>No.</th>
                                    <th>Fecha</th>
                                    <th>Placa</th>
                                    <th>Marca</th>
                                    <th>Color</th>
                                    <th>Infracciones</th>
                                    <th>Total</th>
                                    <th>Estado</th>
                                    <th>Acciones</th>
            
                                </tr>

                            </thead>

                            <tbody>

                                {multasFiltradas.map((multa) => (

                                    

                                    <tr key={multa.idmulta}>

                                        

                                        <td>{multa.idmulta}</td>

                                        <td>{multa.fecha}</td>

                                        <td>
                                            <strong>
                                             {multa.tipoplaca}{multa.placa}
                                            </strong>
                                        </td>

                                        <td>{multa.marca}</td>
                                        <td>{multa.color}</td>

                                        <td>

                                            <span className="badge bg-danger">
                                                {multa.cantidadInfracciones}
                                            </span>

                                        </td>

                                       

                                        <td>

                                            <strong>
                                                Q. {multa.monto}
                                            </strong>

                                        </td>

                                         <td>

                                            <span
                                                 className={
                                                 multa.estado === "ANULADO"
                                                ? "badge bg-danger"
                                                : multa.estado === "VIGENTE"
                                                ? "badge bg-success"
                                               
                                                : "badge bg-secondary"  
                                                }
>
                                                {multa.estado}
                                            </span>

                                        </td>

                                        <td>

                                           <Link
                                                 to={"/vermulta/" + multa.idmulta}
                                                 className="btn btn-info btn-sm me-2"
                                                 title="Ver Multa"
                                            >
                                                <i className="bi bi-eye"></i>
                                            </Link>

                                           <button
                                                 className="btn btn-secondary btn-sm"
                                                onClick={() => this.imprimirMulta(multa.idmulta)}
                                                title="Imprimir Multa"
                                            >
                                                <i className="bi bi-printer"></i>
                                            </button>
                                               
                                              {multa.estadomulta === 1 && rol === 1 && (
                                           <button
                                                className="btn btn-danger btn-sm ms-1"
                                                onClick={() => this.anularMulta(multa.idmulta)}
                                                title="Anular multa!"
                                            >
                                                <i className="bi bi-x-circle"></i>
                                            </button>
                                                 )}

                                                 {Number(multa.estadomulta) === 4 && (rol === 1 || rol === 2) && (
                                             <button
                                                 className="btn btn-warning btn-sm ms-1"
                                                onClick={() => this.verAnulacion(multa.idmulta)}
                                                title="Ver datos de anulación"
                                             >
                                                <i className="bi bi-info-circle"></i>
                                            </button>
                                            )}

                                        </td>

                                    </tr>

                                ))}

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>
        );
    }
}

export default Listarmultas;